module.exports = __webpack_public_path__ + "static/media/civic-logo-invert-animated.33b81cfe.svg";